import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Returns true if either of start or end time zone has been set
 */
export default function hasCustomTimeZones(startTimeZoneId: string, endTimeZoneId: string) {
    const userConfig = getUserConfiguration();
    const userTimeZone = userConfig.UserOptions.TimeZone;
    return (
        (startTimeZoneId != null || endTimeZoneId != null) &&
        (startTimeZoneId != endTimeZoneId || endTimeZoneId != userTimeZone)
    );
}
